import { gql } from '@apollo/client';
import { data as routerData } from 'react-router';

import type { LoaderFunctionArgs } from '~/types/route-args';
import { isUserLoggedIn } from '~/modules/user/hook/use-user';

export const GET_MATCHED_LAST_BRIEF_API = '/remix-api/get-matched/last-brief';

/**
 * Only the answers that describe the person rather than the request.
 *
 * A previous brief's location, budget and scope belong to whatever project it
 * was about, so they are deliberately absent: carrying them onto a new brief
 * would describe the wrong job. Who the reader is does not change between
 * briefs, which is the one thing worth not asking twice.
 */
const LAST_BRIEF = gql`
    query GetMatchedLastBrief {
        getMyGetMatchedSubmissions(limit: 1) {
            nodes {
                ID
                UserType
            }
        }
    }
`;

export interface GetMatchedLastBrief {
    userType: string | null;
}

export const loader = async ({ context }: LoaderFunctionArgs) => {
    const { client, logger, user } = context;

    if (!isUserLoggedIn(user)) {
        return routerData<GetMatchedLastBrief>({ userType: null });
    }

    try {
        const { data } = await client.query<{
            getMyGetMatchedSubmissions?: {
                nodes?: { UserType?: string | null }[] | null;
            } | null;
        }>({ query: LAST_BRIEF });

        return routerData<GetMatchedLastBrief>({
            userType:
                data?.getMyGetMatchedSubmissions?.nodes?.[0]?.UserType || null,
        });
    } catch (error) {
        // Never worth failing the brief over. Not knowing simply means asking.
        logger.error(`Error in ${GET_MATCHED_LAST_BRIEF_API}`, { error });
        return routerData<GetMatchedLastBrief>({ userType: null });
    }
};
